var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProductHighlightsHybrid = function SvgIconProductHighlightsHybrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    d: "M10.519 5.834a4.17 4.17 0 0 0-3.958 2.859.52.52 0 1 1-.988-.326 5.21 5.21 0 0 1 10.054.62 3.124 3.124 0 0 1-.422 6.22H2.187a.52.52 0 1 1 0-1.042h13.018A2.083 2.083 0 0 0 15.207 10h-.028a.52.52 0 0 1-.52-.464 4.166 4.166 0 0 0-4.14-3.702M1.667 10.52a.52.52 0 0 1 .52-.52h7.29a.52.52 0 0 1 0 1.041h-7.29a.52.52 0 0 1-.52-.52m0 2.083a.52.52 0 0 1 .52-.52h9.373a.521.521 0 0 1 0 1.04H2.187a.52.52 0 0 1-.52-.52"
  })));
};
export default SvgIconProductHighlightsHybrid;